var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coupon" }, [
    _c("h4", [_vm._v("Saldo em crédito disponível")]),
    _vm._v(" "),
    _c("div", [
      _c("label", { staticClass: "checkbox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.useAccountBalance,
              expression: "useAccountBalance"
            }
          ],
          staticClass: "save-checbox",
          attrs: {
            error: _vm.errors.first("store"),
            name: "save-checkbox",
            type: "checkbox",
            disabled: _vm.accountBonus || _vm.canPayWithAccountBalance
          },
          domProps: {
            checked: Array.isArray(_vm.useAccountBalance)
              ? _vm._i(_vm.useAccountBalance, null) > -1
              : _vm.useAccountBalance
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.useAccountBalance,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.useAccountBalance = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.useAccountBalance = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.useAccountBalance = $$c
                }
              },
              function($event) {
                _vm.setAccountBalance()
              }
            ]
          }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "Selecione essa opção se deseja criar utilizar o saldo em créditos para abater parte do valor da limpeza."
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "amount" }, [
        _vm._v(
          _vm._s(
            _vm._f("toCurrency")(
              _vm.user.payment_gateway_account.wallet.available_to_use
            )
          )
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9f2e5ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9f2e5ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/CheckoutMobile/Payable/OrderComponents/AccountBalance.vue
// module id = null
// module chunks = 